import React, { useEffect, useState } from "react";
import {
  Link,
  NavLink,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import axios from "axios";
import "./GlobalVars";
import $ from "jquery";
import "bootstrap";
import { ToastContainer, toast } from 'react-toastify';
function Navbar() {
  const loc = useLocation();
  const pathName = loc.pathname;

  const cssClass = pathName === "/" || "" ? "navbar-home container-fluid " : "";
  const navClass =
    pathName === "/" || ""
      ? "navbar navbar-expand-lg  "
      : "navbar navbar-expand-lg nav-shadow";

  const navBg = {
    backgroundImage: "url(" + window.location.origin + "/images/bg1.jpg" + ")",
    minHeight: "400px",
    aspectRatio: "2/1",
    backgroundRepeat: "no-repeat",
    width: "undefined",
  };

  const navigate = useNavigate();
  const loginData = { email: "", password: "" };
  const [loginInput, setLoginInput] = useState(loginData);
  const [loggedIn, setLoggedIn] = useState("");
  const [navScroll,setNavScroll] = useState("");
  const [isTermsChecked, setIsTermsChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsTermsChecked(e.target.checked);
  };

  const handleLoginData = (e) => {
    setLoginInput({ ...loginInput, [e.target.name]: e.target.value });
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!isTermsChecked) {
      alert("You must accept the terms and conditions to proceed.");
      return;
    }

    try {
      const response = await axios.post(
        global.apiUrl + "/userLogin",
        loginInput
      );
      const status = response.data["status"];
console.log(status);
      if (status === 400) {
        alert("Invalid Credntials/Already Logged In On Other Device");
      } else {
        localStorage.setItem("userId", response.data["data"]["user_id"]);
        localStorage.setItem("api_key", response.data["data"]["api_key"]);
        localStorage.setItem("name", response.data["data"]["f_name"]);
        setLoggedIn(localStorage.getItem("userId"));
        toast.success('Welcome '+ localStorage.getItem('name'), {
          position: "top-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
          
        navigate(0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const userId = localStorage.getItem("userId");
  ///logout
  const logout = async () => {
    
    try
    {
      const response = await axios.post(
        global.apiUrl + "/userLogout",
        { user_id: userId }
      );

      if(response.status === 200)
      {
        localStorage.clear();
        setLoggedIn(false);
        window.location.href = "/";
      }
    }
    catch(e)
    {
      console.log(e);
    }
    
  };

  useEffect(()=>{
    window.addEventListener('scroll',()=>{
      if(window.scrollY < 20)
      {
        setNavScroll('');
      }
      else
      {
        setNavScroll('scrolled');
      }
    })
  },[]);

  useEffect(() => {
    // Function to check user login status
    const checkLoginStatus = async () => {
      try {
        if (userId) {
          const response = await axios.get(
            `${global.apiUrl}/checkUserLoginStatus/${userId}`
          );

          // Check if the user is logged out
          console.log(response.data);
          if (response.data.data === 0) {
            alert("User is logged out. Logging out...");
            localStorage.removeItem("userId"); // Clear user data
            window.location.href = "/"; // Redirect to login page
          }
        }
      } catch (error) {
        console.error("Error checking login status:", error);
      }
    };

    // Set interval to check login status every 10 seconds
    const intervalId = setInterval(checkLoginStatus, 10000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [userId]); // Dependency array includes userId

  

  return (
    <div className={`container-fluid navbar-top ${navScroll}`}>
      <div className="row">
        <nav className={navClass}>
          <div className="container">
            <Link to="/" className="navbar-brand">
              <img
                src={window.location.origin + "/images/logo.png"}
                alt="logo"
                className="img-fluid"
              />
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNavDropdown">
              <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <NavLink
                    to="/"
                    className="nav-link"
                    activeStyle={{ color: "red" }}
                  >
                    Home
                  </NavLink>
                </li>
                {userId == null ? (
                  <>
                  
                <li className="nav-item">
                  <NavLink to="/BuyersServices" className="nav-link">
                    Buyers Services
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to="/ClientServices" className="nav-link">
                    Client Services
                  </NavLink>
                </li>
                </>
                ) : (
                  <>
                  
                  </>
                )
                }
                

                

                {userId == null ? (
                  <>
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Login
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                  
                        <li>
                          <NavLink to="/WatchList" className="nav-link">
                            Watchlist
                          </NavLink>
                        </li>
                        <li>
                          <Link
                            to="/YourWins"
                            className="nav-link"
                            activeClassName="active"
                          >
                            Your Wins
                          </Link>
                        </li>

                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="navbarScrollingDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Hello, {localStorage.getItem("name")}
                      </Link>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="navbarScrollingDropdown"
                      >
                        <li>
                          <NavLink to="/Profile" className="nav-link">
                            Profile
                          </NavLink>
                        </li>
                        
                        
                        <li>
                          <NavLink to="/PayOnline" className="nav-link">
                            Pay Online
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/ChangePassword" className="nav-link">
                            Change Password
                          </NavLink>
                        </li>
                        <li>
                          <Link
                            className="nav-link"
                            activeClassName="active"
                            onClick={logout}
                          >
                            Logout
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </>
                )}
                <li className="nav-item">
                      <Link
                        className="nav-link"
                        to="/ContactUs"
                      >
                        Contact Us
                      </Link>
                    </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header p-0 m-0">
              <img
                src={window.location.origin + "/images/login.png"}
                className="img-fluid"
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  position: "absolute",
                  right: "-7px",
                  color: "#fff",
                  top: "-4px",
                  filter: "invert(1)",
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="col-md-12 d-flex justify-content-center">
                <div className="col-md-10">
                  <h5
                    style={{ textTransform: "uppercase", textAlign: "center" }}
                  >
                    Login With{" "}
                    <span style={{ color: "#3579ba" }}>Indus Spare Bazaar</span>
                  </h5>
                  <form method="POST" encType="multipart/form-data">
                    <div className="mb-4 mt-4  input-wrapper">
                      <label>
                        Mobile <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={handleLoginData}
                        value={loginInput.email}
                        placeholder="Enter Registered Mobile Number"
                        name="email"
                        required
                      />
                    </div>
                    <div className="mb-2  input-wrapper">
                      <label>
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={handleLoginData}
                        value={loginInput.password}
                        placeholder="Enter Your Password"
                        name="password"
                        required
                      />
                      
                    </div>
                    <div className="text-end">
                    <Link to="/forgotPassword" onClick={()=>$("#exampleModal").modal('hide')} className="text-end text-decoration-none">Forgot Password?</Link>
                    </div>
                    <div className="form-check mt-1">
        <input
          className="form-check-input"
          type="checkbox"
          id="termsCheckbox"
          checked={isTermsChecked}
          onChange={handleCheckboxChange}
        />
        <label className="form-check-label" htmlFor="termsCheckbox">
          I Accept The <Link to="/TermsOfUse" target="_blank">Terms And Conditions</Link>
        </label>
      </div>

                    <div className="mt-3">
                      <button
                        type="submit"
                        className="btn btn-primary carCardButton"
                        onClick={handleLogin}
                      >
                        Submit Now
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer text-center d-flex justify-content-center">
              <span>
                Don't Have An Account{" "}
                <Link to="/LoginSignup" onClick={()=>$("#exampleModal").modal('hide')} className="text-decoration-none">
                  Signup
                </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
